import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  overflow: hidden;
  display: flex;
  background: ${({ theme }) => theme.backgroundColor.toolbar};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  button {
    padding: 1.0rem 2.0rem;
  }

  &.zoom {
    padding: 3px;
  }
`

const ToolbarContainer = ({children, ...props}) => {
  return (
    <Wrapper {...props}>
      {children}
    </Wrapper>
  )
}

export default ToolbarContainer;